module.exports = __webpack_public_path__ + "static/media/mapa-a7.92ab7dc2.png";